import React from "react";
import { Button, CircularProgress } from "@mui/material";

interface LoadingButtonProps {
  isLoading: boolean;
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: "text" | "outlined" | "contained";
  color?: "primary" | "secondary" | "error" | "warning" | "info";
  size?: "small" | "medium" | "large";
  className?: string;
  fullWidth?: boolean;
  children: React.ReactNode;
  loadingContent?: React.ReactNode;
  isDisabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const LoadingButton = ({
  isLoading,
  onClick,
  variant = "contained",
  size = "medium",
  children,
  className = "",
  fullWidth = false,
  loadingContent,
  isDisabled = false,
  type = "button",
}: LoadingButtonProps) => {
  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={isDisabled}
      type={type}
    >
      {isLoading
        ? (
            loadingContent || (
              <div className="flex items-center">
                <CircularProgress color="inherit" size={25} />
              </div>
            )
          )
        : (
            children
          )}
    </Button>
  );
};

export default LoadingButton;
